var scope_0 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0b93b8cf4e0d036b8213cdac86abebda.js').default;

var scope_1 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2a55b24e0839a6a760d45e6653b2e88b.js').default;

var scope_2 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4a174b741f4e57eabba72fc028f1e0ec.js').default;

var scope_3 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4d2a1371a412fdca0dff806d87dbc380.js').default;

var scope_4 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7e060370fa2ef90b437625a0439cd4f0.js').default;

var scope_5 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/871cab5790391fc51bed104c449ff9e7.js').default;

var scope_6 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a4e53a96fab1b2c29dab64ae932b2558.js').default;

var scope_7 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b34a5aa2e956b4d2c552063bb00481a4.js').default;

var scope_8 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bd77b56dbee1dca7d880033322503f9c.js').default;

var scope_9 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cad68ade8eabf9217e8ad7bcfa69bf76.js').default;

var scope_10 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ec26957a7695ff96ed04d7c45f8fc6fe.js').default;

var scope_11 = require('/home/atul/WORK/MLH/react-components/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f6c22df7698754edaaadf492a4a201e4.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}